import axios from 'axios';
import useLadyService from './LadyService';
import showToast from '@/components/toast/Toast';

const useVideoCallService = () => {
	const { token, t } = useLadyService();
	const BASE_API_URL = `https://${process.env.REACT_APP_CALL_URL}`;

	function createVideoCallRoom(profile) {
		try {
			return axios.post(
				`${BASE_API_URL}/create`,
				{ profile },
				{ headers: { Authorization: `Bearer ${token}` } }
			);
		} catch (error) {
			console.error(error);
			const res = error.responce;

			showToast({
				message: t('oops'),
				subMessage: `server error ${res?.status}`,
				variant: `error`,
			});
		}
	}

	return {
		createVideoCallRoom,
	};
};

export default useVideoCallService;
